function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24.76 0l-8.666 2.474-4.955 11.145v12.383L-.003 24.763v13.621l9.286-.619h1.236v26.002l-.617 5.57H24.76l-1.239-22.286v-9.906h11.145l3.714-12.382-14.859 1.239v-4.953l1.239-8.669 9.906-1.237h2.477L35.904 0H24.76z",
  fill: "currentColor",
  fillRule: "nonzero"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 70",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzkgNzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIyIj4KICA8cGF0aCBkPSJNMjQuNzYgMGwtOC42NjYgMi40NzQtNC45NTUgMTEuMTQ1djEyLjM4M0wtLjAwMyAyNC43NjN2MTMuNjIxbDkuMjg2LS42MTloMS4yMzZ2MjYuMDAybC0uNjE3IDUuNTdIMjQuNzZsLTEuMjM5LTIyLjI4NnYtOS45MDZoMTEuMTQ1bDMuNzE0LTEyLjM4Mi0xNC44NTkgMS4yMzl2LTQuOTUzbDEuMjM5LTguNjY5IDkuOTA2LTEuMjM3aDIuNDc3TDM1LjkwNCAwSDI0Ljc2eiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz4KPC9zdmc+";
export { SvgFacebook as ReactComponent };